module.exports = __webpack_public_path__ + "static/autocompletes-ee649bba906af4dd9f0dd316ced50198.png";